var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaleSexIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.216 13C4.32 13 3.488 12.776 2.72 12.328C1.968 11.88 1.36 11.28 0.896 10.528C0.448 9.76 0.224 8.92 0.224 8.008C0.224 7.112 0.448 6.296 0.896 5.56C1.36 4.808 1.968 4.208 2.72 3.76C3.488 3.312 4.32 3.088 5.216 3.088C6.272 3.088 7.264 3.416 8.192 4.072L10.424 1.576L8.528 0.639999L12.56 0.183999L12.584 4.24L11.408 2.44L9.128 4.984C9.848 5.864 10.208 6.872 10.208 8.008C10.208 8.92 9.984 9.76 9.536 10.528C9.088 11.28 8.48 11.88 7.712 12.328C6.96 12.776 6.128 13 5.216 13ZM5.216 11.8C5.904 11.8 6.536 11.632 7.112 11.296C7.688 10.944 8.144 10.48 8.48 9.904C8.832 9.328 9.008 8.696 9.008 8.008C9.008 7.336 8.832 6.72 8.48 6.16C8.144 5.584 7.688 5.128 7.112 4.792C6.536 4.456 5.904 4.288 5.216 4.288C4.528 4.288 3.896 4.456 3.32 4.792C2.744 5.128 2.28 5.584 1.928 6.16C1.592 6.72 1.424 7.336 1.424 8.008C1.424 8.696 1.592 9.328 1.928 9.904C2.28 10.48 2.744 10.944 3.32 11.296C3.896 11.632 4.528 11.8 5.216 11.8Z",
    fill: "#27AE60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaleSexIcon);
export default __webpack_public_path__ + "static/media/male_sex_icon.c311bffd7f3e085a59617db5b55762c0.svg";
export { ForwardRef as ReactComponent };